import axios from 'axios';

export default function () {
  axios.defaults.baseURL = document.querySelector('meta[name=ax-base-url]').content;
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.defaults.headers.common.Accept = 'application/json';
}
